import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Field, reduxForm, getFormValues, FieldArray } from 'redux-form';
import LabelSection from 'components/sections/LabelSection';
import {
  onClickAddItems,
  adjustmentFormOnChangeOutlet,
  adjustmentFormOnClickCancel,
} from 'actions/inventory/adjustment';
import SettingField from 'components/Fields/ReduxForm/SettingField';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import validator from 'validator';
import { useMokaOutletPropsFirst } from 'utils/formatter';
import ConfirmSubmitModal from './ConfirmSubmitModal';
import styles from './AdjustmentForm.css';

const validate = (values, props) => {
  const errors = {};
  const adjustmentErrors = [];
  if (values.adjustments) {
    values.adjustments.forEach((member, index) => {
      const memberErrors = {};
      if (!member.quantity && `${member.quantity}` !== '0') {
        memberErrors.quantity = 'Please enter a value';
        adjustmentErrors[index] = memberErrors;
      } else if (
        props.namespace === 'ingredients' &&
        !validator.isDecimal(`${member.quantity}`)
      ) {
        memberErrors.quantity = 'Please enter a valid Number';
        adjustmentErrors[index] = memberErrors;
      } else if (
        props.namespace === 'items' &&
        !validator.isNumeric(`${member.quantity}`)
      ) {
        memberErrors.quantity = 'Please enter a valid Number';
        adjustmentErrors[index] = memberErrors;
      } else if (
        props.namespace === 'items' &&
        parseFloat(member.quantity) - 999999999 > 0.000001
      ) {
        memberErrors.quantity = 'Quantity must be less than 999999999';
        adjustmentErrors[index] = memberErrors;
      } else if (
        props.namespace === 'ingredients' &&
        parseFloat(member.quantity) - 999999999.99 > 0.000001
      ) {
        memberErrors.quantity = 'Quantity must be less than 999999999.99';
        adjustmentErrors[index] = memberErrors;
      }
    });
  }
  if (adjustmentErrors.length) {
    errors.adjustments = adjustmentErrors;
  }
  return errors;
};
const popoverFocus = ({ content }) => (
  <Popover id="adjustment">{content}</Popover>
);

const toNonNegative = value => {
  if (isNaN(value)) {
    return '';
  }
  if (value === '') {
    return '';
  }
  // ni gak pake fungsi abs karena kalo ngetik 100.0 di abs jatuhnya 100
  if (value < 0) {
    return -value;
  }
  return value;
};

const renderAdjustment = (member, index, fields) => {
  const adjustmentObject = fields.get(index);
  let adjustmentValue =
    adjustmentObject.quantity - adjustmentObject.beginning_stock;
  if (isNaN(adjustmentValue)) {
    adjustmentValue = 0;
  }
  const formattedAdjustmentValue =
    adjustmentValue > 0 ? `+${adjustmentValue}` : `${adjustmentValue}`;
  // kalo nemu value yang dirender pake <input> tag
  // tapi bingung di mana dia di set valuenya
  // silakan cek saga-effect confirmAddItems sama Form pada komponent AddItemsModal
  return (
    <div className="col-sm-12 mk-grouped-input">
      <div className="form-group col-sm-3">
        {!adjustmentObject.is_item && (
          <OverlayTrigger
            placement="top"
            overlay={popoverFocus({
              content: adjustmentObject.item_variant_name,
            })}
          >
            <Field
              component="input"
              name={`${member}.item_variant_name`}
              className={`form-control ${styles['item-variant-name']}`}
              disabled
            />
          </OverlayTrigger>
        )}
        {adjustmentObject.is_item && (
          <OverlayTrigger
            placement="top"
            overlay={popoverFocus({ content: adjustmentObject.item_name })}
          >
            <Field
              component="input"
              name={`${member}.item_name`}
              className={`form-control ${styles['item-name']}`}
              disabled
            />
          </OverlayTrigger>
        )}
      </div>
      <div className="form-group col-sm-3">
        <Field
          component="input"
          name={`${member}.beginning_stock`}
          className={`form-control ${styles['beginning-stock']}`}
          disabled
        />
      </div>
      <div className="form-group col-sm-3">
        <Field
          component={SettingField}
          name={`${member}.quantity`}
          className="form-control"
          positiveNumberOnly
          maxFractionDigits={0}
          normalize={toNonNegative}
        />
      </div>
      <div className="form-group col-sm-3">
        <input
          className={`form-control ${styles.adjustment}`}
          value={formattedAdjustmentValue}
          disabled
        />
        {adjustmentObject.is_item && (
          <span
            onClick={() => {
              let i = 0;
              fields.getAll().forEach((item, idx) => {
                if (item.item_id === adjustmentObject.item_id) {
                  fields.remove(idx - i);
                  i++;
                }
              });
            }}
            className={styles['btn-delete-wrapper']}
          >
            <i className="fa fa-times-circle" />
          </span>
        )}
      </div>
    </div>
  );
};

const renderIngredientArray = ({ fields }) => {
  return (
    <div>
      {fields.map((member, index, fields) => {
        const values = fields.get(index);
        const diff = Number(values.quantity - values.beginning_stock).toFixed(
          2
        );
        const formattedAdjustmentValue = !isNaN(diff)
          ? diff > 0
            ? `+${diff}`
            : `${diff}`
          : 0;
        return (
          <div key={index} className="row mb-20px">
            <div className="col-sm-12">
              <div className="col-sm-3 text-center">UNIT</div>
              <div className="col-sm-3 text-center">IN STOCK</div>
              <div className="col-sm-3 text-center">ACTUAL STOCK</div>
              <div className="col-sm-3 text-center">ADJUSTMENT</div>
            </div>
            <div className="col-sm-12">
              <div className="mk-grouped-input">
                <div className="form-group col-sm-12">
                  <Field
                    component="input"
                    name={`${member}.ingredient_name`}
                    className={`form-control ${styles['ingredient-name']}`}
                    disabled
                  />
                </div>
              </div>
              <div className="mk-grouped-input">
                <div className="form-group col-sm-3">
                  <Field
                    component="input"
                    name={`${member}.unit_name`}
                    className={`form-control ${styles['unit-name']}`}
                    disabled
                  />
                </div>
                <div className="form-group col-sm-3">
                  <Field
                    component="input"
                    name={`${member}.beginning_stock`}
                    className={`form-control ${styles['beginning-stock']}`}
                    disabled
                  />
                </div>
                <div className="form-group col-sm-3">
                  <Field
                    component={SettingField}
                    name={`${member}.quantity`}
                    className={`form-control ${styles['end-stock']}`}
                    positiveNumberOnly
                    maxFractionDigits={2}
                    normalize={toNonNegative}
                  />
                </div>
                <div className="form-group col-sm-3">
                  <input
                    className={`form-control ${styles.adjustment}`}
                    disabled
                    value={formattedAdjustmentValue}
                  />
                  <span
                    onClick={() => {
                      fields.remove(index);
                    }}
                    className={styles['btn-delete-wrapper']}
                  >
                    <i className="fa fa-times-circle" />
                  </span>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

const renderAdjustmentArray = ({ fields }) => {
  let lastItemId = 0;
  const doms = [];
  let inputdoms = [];
  fields.forEach((...props) => {
    const [member, index] = props;
    const field = fields.get(index);
    const shouldRenderHeader = lastItemId === 0 || field.item_id !== lastItemId;
    const shouldRenderItemNameRow = !field.is_item;
    lastItemId = field.item_id;

    if (shouldRenderHeader) {
      if (inputdoms.length) {
        doms.push(
          <div className="row mb-20px">
            <div className="col-sm-12">{inputdoms}</div>
          </div>
        );
        inputdoms = [];
      }
      doms.push(
        <div className="col-sm-12 mt-10px">
          <div className="col-sm-3 text-center">
            {!field.is_item && 'VARIANT'}
            {field.is_item && 'ITEM'}
          </div>
          <div className="col-sm-3 text-center">IN STOCK</div>
          <div className="col-sm-3 text-center">ACTUAL STOCK</div>
          <div className="col-sm-3 text-center">ADJUSTMENT</div>
        </div>
      );
    }

    if (shouldRenderHeader && shouldRenderItemNameRow) {
      inputdoms.push(
        <div className="col-sm-12 mk-grouped-input">
          <div className="form-group col-sm-12">
            <Field
              component="input"
              name={`${member}.item_name`}
              className={`form-control ${styles['item-name-header']}`}
              disabled
            />
            {!field.is_item && (
              <span
                onClick={() => {
                  let i = 0;
                  fields.getAll().forEach((item, idx) => {
                    if (item.item_id === field.item_id) {
                      fields.remove(idx - i);
                      i++;
                    }
                  });
                }}
                className={styles['btn-delete-wrapper']}
              >
                <i className="fa fa-times-circle" />
              </span>
            )}
          </div>
        </div>
      );
    }
    inputdoms.push(renderAdjustment(...props));
  });
  if (inputdoms.length) {
    doms.push(
      <div className="row mb-20px">
        <div className="col-sm-12">{inputdoms}</div>
      </div>
    );
  }
  return (
    <div
      className={`row mk-grouped-list-input ${
        styles['adjustment-item-wrapper']
      }`}
    >
      {doms}
    </div>
  );
};

class AdjustmentForm extends React.Component {
  render() {
    const outletDropdowns = this._outletDropdowns();
    let outletDropdownClassName = '';
    if (outletDropdowns.length === 1) {
      outletDropdownClassName = `${styles['outlet-dropdown']} ${styles.single}`;
    } else {
      outletDropdownClassName = `${styles['outlet-dropdown']} ${
        styles.multiple
      }`;
    }
    return (
      <form className={styles.wrapper} onSubmit={this.props.handleSubmit}>
        <div className={`${styles['form-content']} adjustment-form-content`}>
          <LabelSection title="choose outlet" />
          <div className="form-group">
            <Field
              name="outlet_id"
              component="select"
              onChange={this._onChangeOutletId}
              className={`form-control ${outletDropdownClassName}`}
              disabled={outletDropdowns.length === 1}
            >
              {outletDropdowns.map(o => (
                <option value={o.id} key={o.id}>
                  {useMokaOutletPropsFirst(o, outlet => outlet.name)}
                </option>
              ))}
            </Field>
          </div>
          <LabelSection title="note" />
          <div className="form-group mb-20px">
            <Field
              component="textarea"
              placeholder="Notes"
              name="note"
              className="form-control"
              rows={5}
            />
          </div>
          <LabelSection title="adjustment stock table" />
          <div className="mb-20px">
            {this.props.namespace === 'items' && (
              <FieldArray
                name="adjustments"
                component={renderAdjustmentArray}
                adjustmentForm={this.props.adjustmentForm}
              />
            )}
            {this.props.namespace === 'ingredients' && (
              <FieldArray
                name="adjustments"
                component={renderIngredientArray}
              />
            )}
          </div>
          <div className="form-group">
            {this._isMaxItems() && (
              <OverlayTrigger
                placement="top"
                overlay={popoverFocus({
                  content: (
                    <span>
                      You can only make adjustment to 50 items at a time. Please
                      use <strong>Import Adjustment</strong> if you want to make
                      Adjustment for more than 50 items.
                    </span>
                  ),
                })}
              >
                <button
                  className={`btn btn-primary ${
                    styles['btn-addItems-disabled']
                  }`}
                  onClick={event => {
                    event.preventDefault();
                    event.stopPropagation();
                  }}
                >
                  {this._addItemsLabel()}
                </button>
              </OverlayTrigger>
            )}
            {!this._isMaxItems() && (
              <button
                className={`btn btn-primary ${styles['btn-addItems']}`}
                onClick={this._onClickAddItems}
              >
                {this._addItemsLabel()}
              </button>
            )}
          </div>
        </div>
        <div className={styles['form-footer']}>
          <span className="pull-right">
            <button
              className={`btn btn-default ${styles['btn-done']} mr-10px`}
              onClick={this._onClickCancel}
              type="button"
            >
              Cancel
            </button>
            <button className={`btn btn-primary ${styles['btn-done']}`}>
              Create
            </button>
          </span>
        </div>
        <ConfirmSubmitModal />
      </form>
    );
  }

  _onClickCancel = () => {
    this.props.dispatch(adjustmentFormOnClickCancel());
  };

  _onChangeOutletId = (event, outletId) => {
    this.props.dispatch(adjustmentFormOnChangeOutlet(outletId));
  };

  _onClickAddItems = event => {
    event.preventDefault();
    event.stopPropagation();
    const { adjustmentForm, namespace } = this.props;
    this.props.dispatch(onClickAddItems(adjustmentForm.outlet_id, namespace));
  };

  _outletDropdowns = () => {
    const { outlets, search } = this.props;
    if (!search || !search.outletIds) {
      return [];
    }
    if (search.outletIds.length > 1) {
      return outlets;
    }
    const data = [];
    outlets.forEach(d => {
      if (search.outletIds[0] === d.id) {
        data.push(d);
      }
    });
    return data;
  };

  _addItemsLabel = () => {
    const { search } = this.props;
    if (search && search.namespace === 'items') {
      return 'Add Items';
    }
    return 'Add Ingredients';
  };

  _isMaxItems() {
    const { adjustmentForm } = this.props;
    if (adjustmentForm) {
      const totalItems = _.uniqBy(adjustmentForm.adjustments, 'item_id').length;
      if (totalItems >= 50) {
        return true;
      }
    }
    return false;
  }
}

const mapForm = {
  form: 'adjustment',
  validate,
  touchOnBlur: true,
  touchOnChange: true,
};

function mapStateToProps(state) {
  const {
    outlets,
    showAddItemsModal,
    addItemsButtonDisabledState,
  } = state.inventory.adjustment;
  return {
    outlets,
    showAddItemsModal,
    addItemsButtonDisabledState,
    search: getFormValues('search')(state),
    adjustmentForm: getFormValues('adjustment')(state),
  };
}

const connected = connect(mapStateToProps)(reduxForm(mapForm)(AdjustmentForm));

export default connected;
